import Vue from 'vue'
import App from './App.vue'
import logger from 'vuejs-text-logger'

const options = {
    logs: true, 
    logsPath: '/', 
    appendDate: true, 
    maxFileDimension: 50
};
Vue.use(logger, options);

Vue.config.productionTip = false
Vue.config.devtools = true
window.onload = function () {
  new Vue({
    render: h => h(App),
  }).$mount('#app')
}
